<template>
    <div class="add-to-list-modal">

        <div class="add-to-list-modal__shade" @click="closeModal()"></div>

        <div class="add-to-list-modal__main">

            <!-- Close -->
            <span class="add-to-list-close" @click="closeModal()">
                <svg class="close"><use xlink:href="#close"></use></svg>
            </span>

            <!-- Header -->
            <h2>Add to List</h2>

            <!-- Form -->
            <form method="post" class="form" @submit.prevent="submit">

                <!-- Select List -->
                <div class="form__row">

                    <!-- Lists Select Input -->
                    <div class="form__field form__field--select" @click="revertNewList()">
                        <select id="list-select" :required="!newList" name="list-select" v-model="addSpotForm.list_id" :disabled="newList">
                            <option disabled value="new" v-show="newList">Select List</option>
                            <option disabled :value="null" selected="selected">Select List</option>
                            <optgroup label="Most Recent" v-if="mostRecentLists.length > 0">
                                <option v-for="list in mostRecentLists"
                                        :key="list.id"
                                        :value="list.id"
                                        v-text="list.name">
                                </option>
                            </optgroup>
                            <optgroup label="All" v-if="allLists.length > 0">
                                <option v-for="list in allLists"
                                        :key="list.id"
                                        :value="list.id"
                                        v-text="list.name">
                                </option>
                            </optgroup>
                        </select>
                        <div class="error" v-text="addSpotForm.errors.list_id"></div>
                    </div>

                    <!-- New List Button -->
                    <span v-show="!newList" class="list-modal-new-trigger" @click.prevent="createNewList()">
                        New List +
                    </span>
                </div>

                <!-- New List Form -->
                <div class="new-list-inputs" v-show="newList">

                    <!-- Name -->
                    <div class="form__row">
                        <div class="form__field">
                            <input type="text"
                                   :required="newList"
                                   id="list-name"
                                   name="list-name"
                                   placeholder="Enter New List Name" v-model="createListForm.name">
                            <div class="error" v-text="createListForm.errors.name"></div>
                        </div>
                    </div>

                    <!-- Trip Days -->
                    <div class="form__row form__date">
<!--                        <div class="form__row__left">-->
<!--                            <label for="trip_dates">Trip Dates</label>-->
<!--                        </div>-->
                        <div class="form__row__right">
                            <div class="form__field">
                                <input type="text"
                                       style="cursor: pointer"
                                       @click="selectDates('open-add-to-list-dialog')"
                                       placeholder="Add trip dates or days (optional)" readonly :value="inputDateValue">
                                <span class="text-info">Trip dates/days are optional. Only you can see trip dates.</span>
                            </div>
                        </div>
                    </div>

                    <!-- Secret -->
                    <div class="form__row secret-toggle-row">
                        <div class="form__row__left">
                            <label for="secret">Secret List</label>
                        </div>
                        <div class="form__row__right">
                            <div class="form__field secret-toggle">
                                <input type="checkbox" name="secret" id="secret" v-model="createListForm.secret" value="yes">
                                <div class="switch"><span></span></div>
                                <p>When on only you will be able to see this list.</p>
                            </div>
                        </div>
                    </div>


                </div>

                <!-- Caption -->
                <div class="form__row">
                    <div class="form__field">
                        <textarea v-model="addSpotForm.caption" :placeholder="placeholder"></textarea>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class='form__row button-row'>

                    <button type="submit"
                            class="list-modal-submit"
                            :class="{ 'is-submitting dis': isDisabled }"
                            :disabled="isDisabled">

                        <svg class="save"><use xlink:href="#save"></use></svg>

                        {{ isDisabled ? 'Adding' : ' Add to List' }}

                        <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                    </button>
                </div>

            </form>
        </div>
    </div>

</template>

<script>

import Form from '@/classes/Form'
import Helpers from '@/mixins/Helpers'
import AddToListResources from '@/mixins/AddToListResources'

export default {

    mixins:[AddToListResources, Helpers],

    data() {
        return {
            lists: [],
            newList: false,
            placeholder: 'Notes',
            createListForm: null,
            addSpotForm: null,
            currentElement: null,
            spotsInMyLists: [],
            currentType: 'spot',
        }
    },

    created() {
        this.spotsInMyLists = config.user.in_list_spots_ids
        this.setForms()
        this.fetchUserLists();
        eventBus.$on('checkSpotsInList', this.checkIfSpotsHaveBeenAddedToAList)

        eventBus.$on('open-add-to-list-dialog', event => {
            this.createListForm.trip_date = event.trip_date
            this.createListForm.trip_days = event.trip_days
            this.openModal()
        });
    },

    mounted() {
        this.registerListener()
        this.checkIfSpotsHaveBeenAddedToAList()
    },

    methods: {

        fetchUserLists() {
            axios.get(`/user/lists`)
                .then((response) => {
                    this.lists = _.filter(response.data.lists, list => {
                        return list.user_id == config.user.id
                    });
                    this.selectListFromSource()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        // If the list should be selected automatically from the source url
        selectListFromSource() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('source-list')) {
                let listSlugSource = urlParams.get('source-list')
                this.currentElement = $('.list-add-trigger.spot-page')
                if (listSlugSource && (this.currentElement.length > 0)) {
                    let list = _.find(this.lists, list => list.slug == listSlugSource)
                    if (list) {
                        this.addSpotForm.list_id = list.id
                        let currentSpotTitle = this.currentElement.data('title')
                        this.addSpotForm.spot_id = this.currentElement.data('id')
                        this.placeholder = `Add a note about ${currentSpotTitle} (optional)`;
                        this.openModal()
                    }
                }
            }
        },

        createNewList() {
            this.addSpotForm.list_id = null;
            this.newList = true;
        },

        revertNewList() {
            if (this.newList == true) {
                this.addSpotForm.list_id == null
                this.newList = false;
            }
        },

        submit() {

            if (this.newList) {
                this.createList()
                return
            }

            if (this.addSpotForm.list_id == null) {
                this.addSpotForm.errors.add('list_id', 'Please select or create a list')
                return
            }

            this.addSpotToList();
        },

        createList() {
            this.createListForm.post(`/${config.user.username}/lists`)
                .then(response => {
                    this.addSpotForm.list_id = response.list.id;
                    this.addSpotToList()
                    this.fetchUserLists()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        addSpotToList() {
            let url = this.currentType === 'partner'
                ? `/lists/${this.addSpotForm.list_id}/partner`
                : `/lists/${this.addSpotForm.list_id}/spot`

            this.addSpotForm.post(url)
                .then(response => {
                    if (this.currentType !== 'partner') {
                        this.spotsInMyLists.push(this.addSpotForm.spot_id)
                    }
                    this.closeModal()
                    this.currentElement.addClass("is-on-my-list ")
                    this.checkIfSpotsHaveBeenAddedToAList()
                    this.checkRedirectToList()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        checkRedirectToList() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('source-list')) {
                const listSlug = urlParams.get('source-list');
                this.redirectTo(`/${config.user.username}/list/${listSlug}#schedule`)
            }
        },

        closeModal(reset = true) {
            if(reset){
                this.setForms()
            }
            $('.add-to-list-modal').fadeOut()
        },

        openModal() {
            $('.add-to-list-modal').fadeIn()
        },

        registerListener() {
            var that = this;

            // Register the listener to open the modal
            $(document).on('click', '.list-add-trigger', function (e) {
                that.currentElement = $(this)
                that.fetchUserLists()
                let currentTitle = $(this).data('title')
                let type = $(this).data('type') || 'spot'
                that.currentType = type
                if (type === 'partner') {
                    that.addSpotForm.partner_id = $(this).data('id')
                    that.addSpotForm.spot_id = null
                } else {
                    that.addSpotForm.spot_id = $(this).data('id')
                    that.addSpotForm.partner_id = null
                }
                that.placeholder = `Add a note about ${currentTitle} (optional)`;
                that.openModal()
            })

            // Register click on new list when saving a spot
            $('.list-modal-new-trigger').on('click', function () {
                $(this).siblings().addClass('dis')
                $('.list-modal-submit').addClass('dis')
                $('.new-list-inputs').slideDown()
            })

            // Make the select available
            $('.add-to-list-modal__main .form__field--select').on('click', function () {
                if ($(this).hasClass('dis')) {
                    $(this).removeClass('dis')
                    $('.new-list-inputs').slideUp()
                }
            })

            $('.add-to-list-modal select').on('change', function () {
                $('.list-modal-submit').removeClass('dis')
            })

            $('.add-to-list-modal input').on('keydown', function () {
                $('.list-modal-submit').removeClass('dis')
            })
        },

        setForms() {
            this.addSpotForm = new Form({
                spot_id: null,
                partner_id: null,
                list_id: null,
                caption: '',
            })
            this.createListForm = new Form({
                name: '',
                trip_date: null,
                trip_days: null,
                description: '',
                secret: false,
            })
        },

        checkIfSpotsHaveBeenAddedToAList() {
            this.$nextTick(() => {
                let buttonTriggers = document.getElementsByClassName('list-add-trigger')
                buttonTriggers.forEach(btn => {
                    if (this.spotsInMyLists.includes(parseInt(btn.dataset.id))) {
                        btn.classList.add("is-on-my-list")
                        if (btn.classList.contains('spot-page')) {
                            btn.innerHTML = `<svg class='save'><use xlink:href="#save"></use></svg>Added to List`
                        }
                    }
                })
            })
        },

        selectDates(from) {
            this.closeModal(false)
            eventBus.$emit('open-add-dates-to-list-dialog', {
                form: this.createListForm,
                from: from
            })
        },
    },

    computed: {
        isDisabled() {
            return this.addSpotForm.isSubmitted || this.createListForm.isSubmitted
        },

        inputDateValue() {
            if (this.createListForm.trip_date == null && this.createListForm.trip_days == null) {
                return ''
            }
            if (this.createListForm.trip_date) {
                let fromDate = moment(this.createListForm.trip_date).utc()
                let newDate = moment(this.createListForm.trip_date).utc().add((this.createListForm.trip_days - 1), 'days')
                return fromDate.format('MMM Do') + ' to ' + newDate.format('MMM Do')
            }
            return this.createListForm.trip_days + ' ' + this.pluralize('Day', this.createListForm.trip_days);
        }
    }
}
</script>
